import actionTypes from "../actions/onBoardingActionTypes";
import {
  BANK_LOCATION_OTHER_OPTION,
  OTHER_OPTION
} from "../constants/constants";
import { decrypt } from "../util/helpers";
import {
  getSelectedBankLocationOption,
  getSelectedBankNameOption,
  getSelectedIFSCCodeOption
} from "../util/onBoardingDataFilters";
import _ from "lodash";

const initialState = {
  generalDetails: {
    id: "",
    updatedBy: "",
    roleId: "",
    createdDate: "",
    updatedDate: "",
    status: 0,
    approved: 0
  },
  personalDetails: {}
};

export function onBoardingDetails(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_PERSONAL_DETAILS:
      const { bankName, bankIFSCCode, bankLocation } =
        action.res && action.res.userDetails;
      const decryptedBankName = decrypt(bankName);
      const decryptedIFSCCode = decrypt(bankIFSCCode);
      const decryptedBankLocation = decrypt(bankLocation);

      const selectedBankNameOption =
        getSelectedBankNameOption(decryptedBankName);
      const selectedIFSCCodeOption =
        getSelectedIFSCCodeOption(decryptedIFSCCode);
      const selectedBankLocationOption = getSelectedBankLocationOption(
        decryptedBankLocation
      );
      const bankAccountNumber = decrypt(
        action.res.userDetails.bankAccountNumber
      );
      return {
        ...state,
        generalDetails: {
          id: action.res.id,
          updatedBy: action.res.updatedBy,
          roleId: action.res.roleId,
          createdDate: action.res.createdDate,
          updatedDate: action.res.updatedDate,
          status: action.res.status,
          approved: action.res.approved
        },
        personalDetails:
          action.res && action.res.userDetails
            ? {
                ...action.res.userDetails,
                bankAccountNumber,
                confirmBankAccountNumber: bankAccountNumber,
                bankBranch: decrypt(action.res.userDetails.bankBranch),
                bankIFSCCode: selectedIFSCCodeOption,
                bankLocation: selectedBankLocationOption,
                bankName: selectedBankNameOption,
                panCardNo: decrypt(action.res.userDetails.panCardNo),
                pfUanNo: decrypt(action.res.userDetails.pfUanNo),
                adhaarNumber: decrypt(action.res.userDetails.adhaarNumber),
                previousPFNumber: decrypt(
                  action.res.userDetails.previousPFNumber
                ),
                accountNumber: decrypt(action.res.userDetails.accountNumber),
                iFSCCode: decrypt(action.res.userDetails.iFSCCode),
                passportNo: decrypt(action.res.userDetails.passportNo),
                schemeCertificateNumber: decrypt(
                  action.res.userDetails.schemeCertificateNumber
                ),
                isEarlierEPF1952Scheme:
                  action.res.userDetails.isEarlierEPF1952Scheme == 0 ? 0 : 1,
                isEarlierEPF1995Scheme:
                  action.res.userDetails.isEarlierEPF1995Scheme == 0 ? 0 : 1,
                isInternationalWorker:
                  action.res.userDetails.isInternationalWorker == 1 ? 1 : 0
              }
            : {},
        otherBankDetails: {
          otherBankName:
            selectedBankNameOption == OTHER_OPTION.id ? decryptedBankName : "",
          otherBankLocation:
            selectedBankLocationOption == BANK_LOCATION_OTHER_OPTION.id
              ? decryptedBankLocation
              : "",
          otherIFSCCode:
            selectedIFSCCodeOption == OTHER_OPTION.id ? decryptedIFSCCode : ""
        }
      };
    case actionTypes.UPDATE_PERSONAL_DETAILS:
      if (action.objName) {
        const personalDetails = state.personalDetails;
        const objDetails = _.get(personalDetails, action.objName);
        const updatedObjDetails = objDetails.map(obj => {
          if (obj.id === action.id)
            return {
              ...obj,
              [action.fieldName]: action.fieldValue
            };
          return { ...obj };
        });
        const updatedPersonalDetails = {
          ...personalDetails,
          [action.objName]: updatedObjDetails
        };
        return { ...state, personalDetails: updatedPersonalDetails };
      } else {
        return {
          ...state,
          personalDetails: {
            ...state.personalDetails,
            [action.fieldName]: action.fieldValue
          }
        };
      }
    case actionTypes.UPDATE_OTHER_BANK_DETAILS: {
      return {
        ...state,
        otherBankDetails: {
          ...state.otherBankDetails,
          [action.fieldName]: action.fieldValue
        }
      };
    }
    case actionTypes.GET_RELATIONSHIP_LIST:
      return { ...state, relationShipList: action.res };
    case actionTypes.ADD_RELATION_DETAILS:
      const updatedFamilyMembers = state.personalDetails.familyMembers.concat(
        action.newRelationDetails
      );

      return {
        ...state,
        personalDetails: {
          ...state.personalDetails,
          familyMembers: updatedFamilyMembers
        }
      };
    case actionTypes.DELETE_RELATION_DETAILS:
      return {
        ...state,
        personalDetails: {
          ...state.personalDetails,
          familyMembers: state.personalDetails.familyMembers.filter(
            relation => relation.id !== action.relationId
          )
        }
      };
    case actionTypes.ADD_GRATUITY_NOMINEE_DETAILS:
      const updatedGratuityNominees =
        state.personalDetails.gratuityNomination.concat(
          action.newGratuityDetails
        );

      return {
        ...state,
        personalDetails: {
          ...state.personalDetails,
          gratuityNomination: updatedGratuityNominees
        }
      };
    case actionTypes.DELETE_GRATUITY_NOMINEE_DETAILS:
      return {
        ...state,
        personalDetails: {
          ...state.personalDetails,
          gratuityNomination: state.personalDetails.gratuityNomination.filter(
            nominee => nominee.familyMemberId !== action.familyMemberId
          )
        }
      };
    case actionTypes.UPDATE_NOMINEE_DETAILS:
      const personalDetails = state.personalDetails;
      const objDetails = _.get(personalDetails, action.objName);
      const updatedObjDetails = objDetails.map(obj => {
        if (obj.familyMemberId === action.id)
          return {
            ...obj,
            [action.fieldName]: action.fieldValue
          };
        return { ...obj };
      });
      const updatedPersonalDetails = {
        ...personalDetails,
        [action.objName]: updatedObjDetails
      };
      return { ...state, personalDetails: updatedPersonalDetails };
    case actionTypes.ADD_EPFFORM2_NOMINEE_DETAILS:
      const updatedPFDetails = state.personalDetails.ePFNomineeDetails.concat(
        action.newPFDetails
      );

      return {
        ...state,
        personalDetails: {
          ...state.personalDetails,
          ePFNomineeDetails: updatedPFDetails
        }
      };
    case actionTypes.DELETE_EPFFORM2_NOMINEE_DETAILS:
      return {
        ...state,
        personalDetails: {
          ...state.personalDetails,
          ePFNomineeDetails: state.personalDetails.ePFNomineeDetails.filter(
            nominee => nominee.familyMemberId !== action.familyMemberId
          )
        }
      };
    default:
      return state;
  }
}
